/**
 * Material-UI theme configuration
 */

import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#667eea',
      light: '#9fa8f4',
      dark: '#4557d2',
    },
    secondary: {
      main: '#764ba2',
      light: '#9d74c0',
      dark: '#5a3780',
    },
    success: {
      main: '#43e97b',
      light: '#7ceda4',
      dark: '#2dcf5f',
    },
    error: {
      main: '#fa709a',
      light: '#fb95b4',
      dark: '#f94c7e',
    },
    warning: {
      main: '#F59E0B',
      light: '#FCD34D',
      dark: '#D97706',
    },
    info: {
      main: '#4facfe',
      light: '#7cc3fe',
      dark: '#2395fe',
    },
  },
  typography: {
    fontFamily: [
      '"Hanken Grotesk"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});
